export default __webpack_public_path__ + "static/media/big-white-logo.4f7fa75f.png";